import React, { FC, ReactNode } from 'react';
import cn from 'classnames';

export enum ButtonPrimaryVariant {
  minimalistic,
  regular
}

export enum ButtonPrimarySize {
  sm = 'h-[32px]',
  md = 'h-[36px]',
  lg = 'h-[38px]',
  xl = 'h-[40px]',
  xll = 'h-[60px]'
}

export enum ButtonPrimaryColor {
  vermilion = 'bg-vermilion text-white hover:bg-outrageousOrange focus:bg-grenadier',
  gray = 'bg-wildSand text-silver'
}

interface Props {
  disabled?: boolean;
  onClick?: (
    event?: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>
  ) => void;
  type?: 'submit' | 'reset' | 'button' | undefined;
  className?: string;
  color?: ButtonPrimaryColor;
  size?: ButtonPrimarySize;
  label?: ReactNode;
  variant?: ButtonPrimaryVariant;
  isLoading?: boolean;
}

const ButtonPrimary: FC<Props> = ({
  disabled = false,
  onClick,
  type = 'button',
  className,
  color = ButtonPrimaryColor.vermilion,
  size = ButtonPrimarySize.xl,
  label,
  variant = ButtonPrimaryVariant.regular,
  ...otherProps
}) => {
  return (
    <div className={cn('fs-body-bold', className)}>
      <button
        className={cn(
          'flex items-center justify-center w-full min-w-[112px] rounded-md px-[16px] py-[8px]',
          disabled && 'cursor-not-allowed',
          color,
          size
        )}
        disabled={disabled}
        onClick={onClick}
        type={type}
        {...otherProps}
      >
        {variant === ButtonPrimaryVariant.regular && (
          <div className="flex w-full h-full">
            {variant === ButtonPrimaryVariant.regular && (
              <div className="flex justify-center items-center w-full">
                {label}
              </div>
            )}
          </div>
        )}
      </button>
    </div>
  );
};

export default ButtonPrimary;
